import { render, staticRenderFns } from "./usrinfo.vue?vue&type=template&id=130af4b8&scoped=true"
import script from "./usrinfo.vue?vue&type=script&lang=js"
export * from "./usrinfo.vue?vue&type=script&lang=js"
import style0 from "./usrinfo.vue?vue&type=style&index=0&id=130af4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130af4b8",
  null
  
)

export default component.exports